export default {
  individual: {
    title: 'Физическое лицо',
    value: 'individual',
  },
  legal: {
    title: 'Юридическое лицо',
    value: 'legal'
  }
}